import {
    GridRenderCellParams,
} from '@mui/x-data-grid-pro'
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import {
    InvoiceStatus,
    InvoiceDesignation,
    ContractCurrency,
    InvoiceType,
} from 'app/enums/label.enums'
import MONTHS_BY_NUMBER from 'app/utils/monthsByNumber'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    LongTermLeaseInvoiceTable,
} from 'app/requests/LongTermLease/LongTermLease.types'

const columns: SkyDataGridColumnDefinition<LongTermLeaseInvoiceTable>[] = [
    {
        name: 'invoiceTitle',
        labelKey: 'INVOICE_TITLE',
    },
    {
        name: 'invoiceDate',
        labelKey: 'INVOICE_DATE',
    },
    {
        name: 'invoiceStatus',
        componentName: 'EnumValue',
        allowedValuesEnum: InvoiceStatus,
        labelKey: 'INVOICE_STATUS',
    },
    {
        name: 'invoiceDesignation',
        componentName: 'EnumValue',
        allowedValuesEnum: InvoiceDesignation,
        labelKey: 'INVOICE_DESIGNATION',
    },
    {
        name: 'invoiceType',
        componentName: 'EnumValue',
        allowedValuesEnum: InvoiceType,
        labelKey: 'INVOICE_TYPE',
    },
    {
        name: 'billedMonth',
        renderCell: (params: GridRenderCellParams<LongTermLeaseInvoiceTable>) => {
            return MONTHS_BY_NUMBER[params.row.billedMonth]
        },
        labelKey: 'BILLED_MONTH',
    },
    {
        name: 'billedYear',
        filterType: FilterType.Array,
        labelKey: 'BILLED_YEAR',
    },
    {
        name: 'billedAmount',
        labelKey: 'BILLING_AMOUNT',
    },
    {
        name: 'currency',
        componentName: 'EnumValue',
        allowedValuesEnum: ContractCurrency,
        labelKey: 'PRICING_CURRENCY',
    },
]

export default columns
